import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, BehaviorSubject } from 'rxjs';
import { OrderServiceProxy, OrderApprovedDto } from '../../../../../../../shared/service-proxies/service-proxies';
import { CustomLocalizationService } from '../../../utility/customLocalization.service';

enum enumOperationTypes {
	rejected = 0,
	approval = 1,
	cancel = 2,
}

@Component({
  selector: 'kt-product-approval-or-reject-modal',
  templateUrl: './product-approval-or-reject-modal.component.html',
  styleUrls: ['./product-approval-or-reject-modal.component.scss']
})
export class ProductApprovalOrRejectModalComponent implements OnInit, OnDestroy{
	
	@Input() operationType;

	isApprovalOrRejected = new BehaviorSubject<boolean>(null);
	approvalConfirmSelected = new BehaviorSubject<boolean>(null);

	message: string = null;
	description : string = null;

	constructor(private modalService: NgbModal,
		private _orderService: OrderServiceProxy,
		private customLocalization: CustomLocalizationService,
	) {
		this.description = "";
	 }


	ngOnInit() {
		if (this.operationType == enumOperationTypes.approval) {
			
			this.message = this.customLocalization.l("FE.APPROVALS.TABS.WAITINGFORAPPROVAL.DELETEMODAL.BODY.APPROVE");
		}
		else if (this.operationType == enumOperationTypes.rejected) {
			
			this.message = this.customLocalization.l("FE.APPROVALS.TABS.WAITINGFORAPPROVAL.DELETEMODAL.BODY.REJECT");
		}
		else if (this.operationType == enumOperationTypes.cancel) {
			
			this.message = this.customLocalization.l("FE.APPROVALS.TABS.WAITINGFORAPPROVAL.DELETEMODAL.BODY.CANCEL");

		}

	}

	modalClose() {
		this.modalService.dismissAll();
	}

	approvalOrRejectOperation() {

		if (this.operationType == enumOperationTypes.approval) {
			
			this.approvalConfirmSelected.next(true);
		}
		else if (this.operationType == enumOperationTypes.rejected) {
			
			this.approvalConfirmSelected.next(true);

		}
		else if (this.operationType == enumOperationTypes.cancel) {

			this.approvalConfirmSelected.next(true);

		}

		this.modalService.dismissAll();

		//burak abinin vereveği method işlemi bittikten sonra subscribe içerisinden yakalanacak
		this.isApprovalOrRejected.next(true);

		
	}

	ngOnDestroy() {
		this.isApprovalOrRejected.unsubscribe();
	}


}
